import * as moment from 'moment';

/**
 * Override di moment.fn.toJSON per serializzare SOLO la data (senza orario).
 *
 * Di default moment usa toISOString() che converte in UTC, causando uno shift in base al fuso orario
 * di qualche ora (e anche del giorno) per le date italiane. Qui forziamo JSON.stringify
 * a usare sempre il formato 'YYYY-MM-DD', così:
 * - non c'è più l'orario
 * - non c'è più problema di fuso orario che cambia il giorno
 *
 * Attenzione: questo vale per TUTTI i moment dell'app. Se da qualche parte ti serve anche l'ora,
 * lì dovrai serializzare esplicitamente con .format(...) invece di affidarti a JSON.stringify.
 */
moment.fn.toJSON = function (): string {
  return this.format('YYYY-MM-DD');
};
